import { ReactNode, useLayoutEffect } from 'react'

import { useAtom } from 'jotai'
import {
  GreyGrey10,
  GreyWhite,
  ShadowL,
  Flex
} from '@sequencehq/core-components'
import { useMediaQuery } from '@sequencehq/utils'
import { showPreviewAtom } from '../Preview'
import { SHOW_PREVIEW_TO_SIDE_MIN_WIDTH } from '../constants'

type Props = {
  leadingSide: ReactNode
  trailingSide: ReactNode
}

export const SplitLayout = ({ leadingSide, trailingSide }: Props) => {
  const [showPreview, setShowPreview] = useAtom(showPreviewAtom)
  const [canShowPreviewToSide] = useMediaQuery(
    `(min-width: ${SHOW_PREVIEW_TO_SIDE_MIN_WIDTH})`
  )

  useLayoutEffect(() => {
    if (canShowPreviewToSide) {
      setShowPreview(true)
    } else {
      setShowPreview(false)
    }
  }, [canShowPreviewToSide, setShowPreview])

  return (
    <Flex maxHeight="100%" height="100%" overflow="hidden">
      <Flex
        flex="1"
        backgroundColor={GreyWhite}
        boxShadow={ShadowL}
        zIndex={1}
        flexDir="column"
        height="100%"
        position="relative"
        display={canShowPreviewToSide ? 'flex' : showPreview ? 'none' : 'flex'}
      >
        {leadingSide}
      </Flex>
      {(canShowPreviewToSide || (!canShowPreviewToSide && showPreview)) && (
        <Flex
          flex={showPreview ? '1' : '0'}
          display={
            canShowPreviewToSide ? 'flex' : showPreview ? 'flex' : 'none'
          }
          transition="flex 200ms"
          overflow="hidden"
          background={`linear-gradient(180deg, ${GreyGrey10} 0%, rgba(248, 250, 252, 0) 100%)`}
        >
          {trailingSide}
        </Flex>
      )}
    </Flex>
  )
}
